var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-flex is-align-items-center mt-4 mb-0"},[_c('span',{staticClass:"is-uppercase has-text-weight-medium has-text-grey is-flex-shrink-0",style:({ fontSize: '.875rem' })},[(_vm.icon)?_c('fa',{staticClass:"fa-fw mr-1 has-text-grey-light",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._t("default")],2),_c('div',{staticClass:"has-background-white-ter",style:({
      height: '4px',
      width: '100%',
      borderRadius: '4px',
      marginLeft: '.5rem',
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }